module.exports = "/assets/e3d27b4e1e763b337009bfd5605de347.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/6L.png
// module id = 2219
// module chunks = 0